
/* START_TEMPLATE */
define('hbs!pricelist/templates/price',['hbs','handlebars','templates/helpers/priceFormat'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, stack2, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div>\r\n	";
  options = {hash:{}};
  buffer += escapeExpression(((stack1 = helpers.priceFormat),stack1 ? stack1.call(depth0, depth0.Amount, options) : helperMissing.call(depth0, "priceFormat", depth0.Amount, options)))
    + " ";
  if (stack2 = helpers.AmountUnitName) { stack2 = stack2.call(depth0, {hash:{}}); }
  else { stack2 = depth0.AmountUnitName; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "\r\n</div>";
  return buffer;
  });
Handlebars.registerPartial('pricelist_templates_price', t);
return t;
});
/* END_TEMPLATE */
;
